import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { cotizacionParametrosService } from "@/services/cotizacion-parametros.service";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";

export const useCotizacionParametros = () => {
  const state = ref({});
  const listaParametros = ref([]);
  const parametros = ref(undefined);
  const camposDeshabilitados = ref(true);
  const modificando = ref(false);
  const router = useRouter();

  const get = async () => {
    try {
      const res = await cotizacionParametrosService.get();
      listaParametros.value = res.data;
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };

  const edit = async () => {
    const route = useRoute();
    try {
      const res = await cotizacionParametrosService.edit(
        route.params.parametro_id
      );
      parametros.value = res.data;
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };

  const update = async () => {
    modificando.value = true;
    try {
      const { data } = await cotizacionParametrosService.update(
        parametros.value.id,
        parametros.value
      );
      router.push({
        name: "cotizacion-unidades-parametros",
      });
      showToast(data.message, "success");
    } catch (error) {
      console.error(error);
      exceptionRequestMsg(error);
    } finally {
      modificando.value = false;
    }
  };

  return {
    camposDeshabilitados,
    edit,
    get,
    listaParametros,
    modificando,
    parametros,
    state,
    update,
  };
};
